// extracted by mini-css-extract-plugin
export default {"nick":"nick_nick__47nHr","tenant":"nick_tenant__C1v8q","prod":"nick_prod__vMp4-","nonProd":"nick_nonProd__rFpgm"};